import {MantenimientoBasculaService} from './../../services/mantenimiento-bascula.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Component, OnInit} from '@angular/core';
import {moduloGaritas} from '../../diccionarios/balanzaModulo.js';

@Component({
  selector: 'app-mantenimiento-basculas',
  templateUrl: './mantenimiento-basculas.component.html',
  styleUrls: ['./mantenimiento-basculas.component.scss'],
})
export class MantenimientoBasculasComponent implements OnInit {
  public loading: boolean = false;

  public DAT_TITULOS: any = moduloGaritas.titulos.mantenimientoBascula;
  public DAT_BTNS: any = moduloGaritas.button.buttonsNombre;
  public DAT_BTNCSS: any = moduloGaritas.button.buttonsCss;
  public DAT_MSG: any = moduloGaritas.mensajes;

  public DAT_AG_GRID: any = moduloGaritas.agGrid;

  public columnDefs: any[] = [];
  public rowData: any[] = [];
  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;

  public isCreate: boolean;
  public tituloModal: string;

  public formBascula = new FormGroup({
    idBascula : new FormControl(1, Validators.required),
    ipBalanza : new FormControl('', [Validators.required, Validators.pattern(/(\b25[0-5]|\b2[0-4][0-9]|\b[01]?[0-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}/), Validators.maxLength(14)]),
    desca     : new FormControl('', [Validators.required, Validators.maxLength(30), Validators.pattern(/[A-Za-z]+/)]),
    estado    : new FormControl('', Validators.required),
    centros   : new FormControl('', Validators.required),
    sensorId  : new FormControl('', Validators.maxLength(10)),
    //apiKey    : new FormControl('', Validators.maxLength(50)),
  });


  public validIP: boolean = false;
  cmbCentros = [];

  constructor(
    private _util: UtilsService,
    private mantenimientoBasculaS: MantenimientoBasculaService
  ) {
  }

  get material() {
    return this.formBascula.get('material');
  }

  get cantidad() {
    return this.formBascula.get('cantidad');
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {headerName:'Id', field:'idBascula', sortable:true, filter:true, width:80,},
      {headerName:'Descripción', field:'desca', sortable:true, filter:true,},
      {headerName:'IP', field:'ipBalanza', sortable:true, filter:true,},
      {headerName:'Estado', field:'estado', sortable:true, filter:true,},
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 60,
        cellRendererParams: {
          onClick: this.editarMantenimientoBascula.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  }

  ngOnInit(): void {
    this.girdComponent();
    this.obtenerMantenimientoBascula();
  }

  obtenerMantenimientoBascula() {
    this.loading = true;
    this.mantenimientoBasculaS.obtener().subscribe(
      (resp) => {
        console.log(resp);
        this.rowData = resp;
        this.loading = false;
      },
      (error) => {
        this.rowData = [];
        this.loading = false;
      }
    );
    this.mantenimientoBasculaS.obtenerCentros().subscribe(
      (resp) => {
        console.log("CEMTROS", resp);
        this.cmbCentros = resp;
      },
      (error) => {
      }
    );

  }

  guardarCrear() {
    this.loading = true;
    if (this.formBascula.invalid) return;
    let data = this.formBascula.getRawValue();

    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.procesar,
        text: `Ip: ${data.ipBalanza}, Descripción: ${data.desca}`,
        action: this.DAT_BTNS.nuevo,
        funcion: this.mantenimientoBasculaS.crear(data),
      })
      .then(() => {
        this.obtenerMantenimientoBascula();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  guardarEditar() {
    this.loading = true;
    if (this.formBascula.invalid) return;
    let data = this.formBascula.getRawValue();
    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.actualizar,
        text: `Ip: ${data.ipBalanza}, Descripción: ${data.desca}`,
        action: this.DAT_BTNS.editar,
        funcion: this.mantenimientoBasculaS.editar(
          data
        ),
      })
      .then(() => {
        this.obtenerMantenimientoBascula();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  editarMantenimientoBascula({rowData}) {
    this.isCreate = false;
    this.tituloModal = this.DAT_TITULOS.tituloActualizar;
    rowData.estado = rowData.estado == 'ACTIVO' ? 0 : 1;
    this.formBascula.patchValue(rowData);
    this.formBascula.get('idBascula').disable();
    this.openModal();
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    if (this.isCreate) this.guardarCrear();
    if (!this.isCreate) this.guardarEditar();
  }

  nueva() {
    this.isCreate = true;
    this.tituloModal = this.DAT_TITULOS.tituloAgregar;
    this.formBascula.reset();
    this.formBascula.get('estado').setValue('');
    this.formBascula.get('centros').setValue('');
    this.formBascula.get('idBascula').disable();
    this.openModal();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  duplicatedIP() {

    this.validIP = false;

    for (let i = 0; i < this.rowData.length; i++) {

      if (this.formBascula.get('ipBalanza').value == this.rowData[i].ipBalanza) {

        if (this.formBascula.get('idBascula').value == this.rowData[i].idBascula) continue;

        this.validIP = true;
        break;

      }
    }

    console.log("this.validIP", this.validIP)

  }

  validForm() {
    console.log(this.formBascula.invalid);
    return (this.formBascula.invalid || this.validIP) ? true : false;
  }


}
